/* eslint-disable jsx-a11y/anchor-is-valid */

const ParameterLimitWidget = ({parameterData, setShowMadalLimitHistory}) => {
  return (
    <div
      onClick={() => setShowMadalLimitHistory(true)}
      className={`card hoverable shadow mb-4 cursor-pointer`}
    >
      <div className='card-body'>
        <div className={`fw-bold fs-3 mb-1`}>Limit</div>

        <div className={`fw-semibold mt-3`}>
          {parameterData?.limit_status === 'O' ? (
            <span className='badge badge-danger'>Over</span>
          ) : parameterData?.limit_status === 'N' ? (
            <span className='badge badge-success'>Normal</span>
          ) : parameterData?.limit_status === 'U' ? (
            <span className='badge badge-danger'>Under</span>
          ) : (
            <span className='badge badge-secondary'>{parameterData?.limit_status}</span>
          )}
        </div>

        <div className={`fw-semibold mt-3`}>
          Min : {parameterData?.min} , Max : {parameterData?.max}
        </div>
      </div>
    </div>
  )
}

export {ParameterLimitWidget}
